import React from 'react';
import './UserFilters.css';

interface UserFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  roleFilter: string;
  onRoleFilterChange: (role: string) => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  roleFilter,
  onRoleFilterChange,
}) => {
  return (
    <div className="user-filters">
      <div className="user-search">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search by name, email, phone..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="user-search-input"
        />
      </div>
      <div className="user-filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="user-filter-select"
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
          <option>Blocked</option>
        </select>
        <select
          value={roleFilter}
          onChange={(e) => onRoleFilterChange(e.target.value)}
          className="user-filter-select"
        >
          <option>All Roles</option>
          <option>Owner</option>
          <option>Customer</option>
          <option>Admin</option>
        </select>
        <button className="user-advanced-filters-btn">
          <span>🔽</span> Advanced Filters
        </button>
      </div>
    </div>
  );
};

export default UserFilters;

